const KEY = 'saloni_recently_viewed_v1';
const MAX_ITEMS = 12;

function readRaw() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = JSON.parse(raw || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeRaw(rows) {
  try {
    localStorage.setItem(KEY, JSON.stringify(rows));
  } catch {
    /* ignore quota / private mode */
  }
}

function normalizeRow(row) {
  const categorySlug = String(row?.categorySlug || row?.category_slug || '').trim();
  const productId = String(row?.productId || row?.product_id || row?.product_external_id || '').trim();
  if (!categorySlug || !productId) return null;
  return { categorySlug, productId };
}

/** @returns {Array<{ categorySlug: string, productId: string }>} */
export function readRecentlyViewed() {
  return readRaw()
    .map(normalizeRow)
    .filter(Boolean)
    .slice(0, MAX_ITEMS);
}

/** Record a product view (most recent first, deduped). */
export function pushRecentlyViewed(categorySlug, productId) {
  const cat = String(categorySlug || '').trim();
  const pid = String(productId || '').trim();
  if (!cat || !pid) return;

  const next = [{ categorySlug: cat, productId: pid }, ...readRaw()
    .map(normalizeRow)
    .filter((row) => row && !(row.categorySlug === cat && row.productId === pid))]
    .slice(0, MAX_ITEMS);

  writeRaw(next);
}

export function recentlyViewedStorageKey() {
  return KEY;
}
